import React from "react";
import * as dc from "dc";
import { ChartTemplate } from "../../mapanalysis/chartTemplate";
import * as d3 from "d3";
import { Remove_empty_bins } from "../../helper/remove_empty_bins";
import { Wrapper } from "../../helper/warpLabels";

//#### Bar Chart

// Create a bar chart and use the given css selector as anchor. You can also specify
// an optional chart group for this chart to be scoped within. When a chart belongs
// to a specific group then any interaction with such chart will only trigger redraw
// on other charts within the same chart group.

const householdsChartFunc = (divRef, ndx) => {
  // dimension by land area
  const household_dim = ndx.dimension(
    (d) => d.household_Land_Area_farming_categories
  );
  //  group by the number of farming househiolds
  const household_area_grp = household_dim
    .group()
      .reduceSum((d) => d.number_of_Farming_Households);
    var f = d3.format(",.0f"); // create a formating functions
    /* dc-js chart object */
  const households = dc.barChart(divRef);

  households
      .width(200)
      .height(220)
      .x(d3.scaleBand())
      .barPadding(1)
      .margins({ left: 2, top: 0, right: 0, bottom: 50 })
      .xUnits(dc.units.ordinal)
      .elasticY(true)
      .title((d) => d.key + ` : ${f(d.value)}`)
      .colorAccessor((d) => d.key)
      .valueAccessor((d) => {
          if (d.value == 0) {
              return d.value
          } else {
              return Math.log10(d.value)
          }

      })
      .ordinalColors(["#B5870D", "#8AB3C9", "#327E73"])

      .brushOn(false)

      .dimension(household_dim)

      .barPadding(0.1)

      .outerPadding(0.05)

      .transitionDuration(1500)

      .on("pretransition", (chart) => {

          chart.title((d) => d.key + ` : ${f(d.value)}`)

      })
        .group(Remove_empty_bins(household_area_grp, null));


  households.on("renderlet", function (d) {
    households.selectAll("g.x.axis .tick text").call(Wrapper, 1); // call the wrapper function
  });

  // returnt the chart instance
  return households;
};

export const NoofHouseHoldPractisingFarming = (props) => (
  // pass the chart instance for renderings
  <ChartTemplate chartFunction={householdsChartFunc} />
);
